export const ModalState = {
  modalType: null,
  modalProps: {}
}



/** WEBPACK FOOTER **
 ** ./model/modalState.js
 **/